var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYou11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.792 0.540522C18.6521 0.76717 19.3325 1.43452 19.5635 2.27816C19.9872 3.81433 20 7 20 7C20 7 20 10.1983 19.5764 11.7218C19.3453 12.5655 18.665 13.2328 17.8049 13.4595C16.2516 13.875 10 13.875 10 13.875C10 13.875 3.7484 13.875 2.19512 13.4595C1.33504 13.2328 0.654685 12.5655 0.42362 11.7218C0 10.1857 0 7 0 7C0 7 0 3.81433 0.410783 2.29075C0.641849 1.44712 1.32221 0.779762 2.18229 0.553114C3.73556 0.137592 9.98716 0.125 9.98716 0.125C9.98716 0.125 16.2388 0.125 17.792 0.540522ZM13.1836 7L7.99743 9.94643V4.05357L13.1836 7Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYou11);
export default __webpack_public_path__ + "static/media/you11.35e40082b3efe053256aa1a9722befaf.svg";
export { ForwardRef as ReactComponent };